import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import EstadoIntegracionPrefactura from './EstadoIntegracionPrefactura';



interface EstadoIntegracionPrefacturaTableProps {
  data: EstadoIntegracionPrefactura[];
  columns: TableColumn<EstadoIntegracionPrefactura>[];
  customStyles: Record<string, any>;
}

const EstadoIntegracionPrefacturaTable: React.FC<EstadoIntegracionPrefacturaTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<EstadoIntegracionPrefactura>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default EstadoIntegracionPrefacturaTable;